import React, { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import AdminSidebar from '../components/AdminSidebar';
import '../style/common.css';
import './ClientWisePO.css';

function ClientWisePO() {
  const [pos, setPOs] = useState([]);
  const [clients, setClients] = useState({});
  const [openClient, setOpenClient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, 'purchase_orders'), snapshot => {
      const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setPOs(data);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  useEffect(() => {
    const clientMap = {};
    pos.forEach(po => {
      const client = po.client || po.client_name || 'Unspecified';
      if (!clientMap[client]) clientMap[client] = [];
      clientMap[client].push(po);
    });
    setClients(clientMap);
  }, [pos]);

  const formatNum = n => n.toLocaleString('en-IN', { maximumFractionDigits: 2 });

  if (loading) return <div>Loading client data...</div>;

  return (
    <div className="dashboard-wrapper">
      <AdminSidebar />
      <div className="dashboard-content">
        <h2 className="dashboard-title">Client-wise PO Summary</h2>
        <div className="client-grid">
          {Object.entries(clients).map(([clientName, list]) => {
            const totalValue = list.reduce((a, p) => a + (p.po_total_amount || 0), 0);
            const pendingValue = list.reduce((a, p) => a + (p.balance_amount || 0), 0);
            const activeCount = list.filter(p => !p.completed).length;
            const completedCount = list.filter(p => p.completed).length;

            const isOpen = openClient === clientName;

            return (
              <div key={clientName} className="client-card">
                <div
                  className="client-header clickable"
                  onClick={() => setOpenClient(isOpen ? null : clientName)}
                >
                  <div>
                    <h3>{clientName}</h3>
                    <p>Total POs: {list.length}</p>
                    <p>Total Amount: ₹{formatNum(totalValue)}</p>
                    <p>Pending: ₹{formatNum(pendingValue)}</p>
                    <p>Active: {activeCount} | Completed: {completedCount}</p>
                  </div>
                  <div className="arrow">{isOpen ? '▲' : '▼'}</div>
                </div>

                {isOpen && (
                  <div className="table-wrapper">
                    <table className="po-table">
                      <thead>
                        <tr>
                          <th>PO#</th>
                          <th>JC</th>
                          <th>Total</th>
                          <th>Balance</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.map(p => (
                          <tr key={p.id}>
                            <td>{p.po_number}</td>
                            <td>{p.jc_number}</td>
                            <td>₹{formatNum(p.po_total_amount)}</td>
                            <td>₹{formatNum(p.balance_amount)}</td>
                            <td style={{ color: p.completed ? 'green' : 'orange' }}>
                              {p.completed ? 'Completed' : 'Active'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default ClientWisePO;
